import { render, staticRenderFns } from "./receiptScan.vue?vue&type=template&id=35e8e9b4&scoped=true"
import script from "./receiptScan.vue?vue&type=script&lang=js"
export * from "./receiptScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8e9b4",
  null
  
)

export default component.exports